<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.33 9.3325H1V4.88875C1 4.39772 1.39772 4 1.88875 4H21.4412C21.9323 4 22.33 4.39772 22.33 4.88875V9.3325Z" fill="#101010"/>
<path d="M22.33 9.33252H1V14.665H22.33V9.33252Z" fill="#EE0000"/>
<path d="M22.33 19.1087C22.33 19.5998 21.9323 19.9975 21.4412 19.9975H1.88875C1.39772 19.9975 1 19.5998 1 19.1087V14.665H22.33V19.1087Z" fill="#FDCF00"/>
</svg>
